import { useNode } from "@craftjs/core";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";

import { SwitchInput } from "@/components/shared/forms";

export const AdvancedSettings = () => {
  const { t } = useTranslation();
  const {
    props,
    actions: { setProp },
  } = useNode((query) => ({
    props: query.props,
  }));

  const handleToggleMuted = useCallback(() => {
    setProp((props) => {
      return (props.isMuted =
        props.isMuted === undefined ? true : !props.isMuted);
    });
  }, [setProp]);

  return (
    <div className="flex flex-col gap-2">
      <span className="text-sm leading-6">
        {t("preference-panel.advanced-settings")}
      </span>

      <SwitchInput
        label={t("preference-panel.mute")}
        data-testid="toggle-mute"
        checked={Boolean(props.isMuted)}
        onChange={handleToggleMuted}
      />
    </div>
  );
};
